import React, { createContext, useContext, useMemo } from 'react';
import { useAuth } from './AuthContext';
import { detectDeviceLocale, normalizeLocale } from '../utils/locales';
import { createWebTranslator } from '../utils/webI18n';

const LocaleContext = createContext({
  locale: 'en-US',
  t: (key, fallback = key, replacements = null) => fallback,
});

export const LocaleProvider = ({ children }) => {
  const { user } = useAuth();
  const locale = normalizeLocale(user?.preferredLocale || detectDeviceLocale());

  const value = useMemo(() => {
    const t = createWebTranslator(locale);

    return {
      locale,
      t,
    };
  }, [locale]);

  return <LocaleContext.Provider value={value}>{children}</LocaleContext.Provider>;
};

export const useLocale = () => useContext(LocaleContext);
